/**
 * GA4 + Bing UET dataLayer helpers for TENSnet Shopify theme.
 * Events are pushed to window.dataLayer for GTM to forward to GA4 / Microsoft UET.
 */
(function (window) {
  'use strict';

  if (window.customDataLayer) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  const config = window.customDataLayerConfig || { currency: 'USD' };
  const CHECKOUT_SELECTOR = '[data-datalayer-checkout], a[href="/checkout"], a[href*="/checkouts/"]';

  function trackViewItem() {
    const el = document.getElementById('datalayer-product');
    if (!el) {
      return;
    }

    let product;

    try {
      product = JSON.parse(el.textContent);
    } catch (error) {
      return;
    }

    const variant = (product.variants || []).find(function (entry) {
      return String(entry.id) === String(product.selectedVariantId);
    }) || product.variants[0];

    if (!variant) {
      return;
    }

    const price = Number(variant.price || 0) / 100;

    window.dataLayer.push({
      event: 'custom_view_item',
      ecommerce: {
        currency: config.currency,
        value: price,
        items: [
          {
            item_id: 'shopify_' + product.id + '_' + variant.id,
            item_name: product.title || '',
            item_brand: product.vendor || '',
            item_category: product.type || '',
            item_variant: variant.title || '',
            price: price,
            quantity: 1
          }
        ]
      }
    });
  }

  function trackPageView(pageType) {
    window.dataLayer.push({
      event: 'custom_page_view',
      page_location: window.location.href,
      page_title: document.title,
      page_path: window.location.pathname,
      page_type: pageType || 'other'
    });
  }

  function trackAddToCart(lineItem) {
    if (!lineItem) {
      return;
    }

    const quantity = Number(lineItem.quantity || 1);
    const price = Number(lineItem.price || 0) / 100;

    window.dataLayer.push({
      event: 'custom_add_to_cart',
      ecommerce: {
        currency: config.currency,
        value: price * quantity,
        items: [
          {
            item_id: 'shopify_' + lineItem.product_id + '_' + lineItem.variant_id,
            item_name: lineItem.product_title || lineItem.title || '',
            item_brand: lineItem.vendor || '',
            item_category: lineItem.product_type || '',
            item_variant: lineItem.variant_title || '',
            price: price,
            quantity: quantity
          }
        ]
      }
    });
  }

  function trackBeginCheckout(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return;
    }

    window.dataLayer.push({
      event: 'custom_begin_checkout',
      ecommerce: {
        currency: cart.currency || config.currency,
        value: Number(cart.total_price || 0) / 100,
        items: cart.items.map(function (lineItem) {
          return {
            item_id: 'shopify_' + lineItem.product_id + '_' + lineItem.variant_id,
            item_name: lineItem.product_title || lineItem.title || '',
            item_brand: lineItem.vendor || '',
            item_category: lineItem.product_type || '',
            item_variant: lineItem.variant_title || '',
            price: Number(lineItem.price || 0) / 100,
            quantity: Number(lineItem.quantity || 1)
          };
        })
      }
    });
  }

  function bindCheckoutTracking() {
    document.addEventListener('click', function (event) {
      const target = event.target.closest(CHECKOUT_SELECTOR);
      if (!target) {
        return;
      }

      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          trackBeginCheckout(cart);
        })
        .catch(function () {});
    });
  }

  window.customDataLayer = {
    trackPageView: trackPageView,
    trackViewItem: trackViewItem,
    trackAddToCart: trackAddToCart,
    trackBeginCheckout: trackBeginCheckout
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCheckoutTracking);
  } else {
    bindCheckoutTracking();
  }
  
})(window);
